import { render, staticRenderFns } from "./PillsTextPage.vue?vue&type=template&id=16e174e8&"
import script from "./PillsTextPage.vue?vue&type=script&lang=js&"
export * from "./PillsTextPage.vue?vue&type=script&lang=js&"
import style0 from "./PillsTextPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports